<template>
  <div>
    <!--  show if shop has an onboarding offer  -->
    <div v-if="accountInfo.onboardingOffer && countdown > 0" class="primary_lighten3">
      <v-card class="pa-3 primary_lighten1 flex-row flex-wrap" flat>
        <div class="white--text d-flex justify-space-between">
          <div class="text-h6">
            {{ $t('Onboarding.chooseNow') }}
            <span class="font-weight-bold">{{ $t('Onboarding.extraDays') }}</span>
          </div>
          <div>
            <div class="text-h5 font-weight-regular">
              <div class="text-h6">
                <v-progress-circular
                  rotate="270"
                  :size="30"
                  :width="15"
                  :value="countdown"
                  color="white"
                  class="mr-4"
                />
                <span class="font-weight-bold">{{ hours }}</span> hrs :
                <span class="font-weight-bold">{{ minutes }}</span> min :
                <span class="font-weight-bold">{{ seconds }}</span> sec
                {{ $t('Onboarding.left') }}
                <v-btn class="mx-4" color="white" outlined @click="goToPricing()">
                  {{ $t('Onboarding.choosePlan') }}
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </div>
    <!-- show when shop is in trial plan and has no offer (countdown <= 0)   -->
    <div
      v-if="
        showTrialAlert === 'trialPlan' &&
        !accountInfo.shopNeedsToChoosePlan &&
        !accountInfo.onboardingOffer &&
        countdown <= 0
      "
      class="primary_lighten1 pa-3 white--text d-flex justify-space-between"
    >
      <div class="text-h6 ml-6">
        {{ $t('Onboarding.youHave') }}
        <span class="font-weight-bold">
          {{ accountInfo.trialDaysLeft }} {{ $t('Onboarding.days') }}
        </span>
        {{ $t('Onboarding.remainingOfTrial') }}
      </div>
      <v-btn class="mx-4" color="white" outlined @click="goToPricing()">
        {{ $t('Onboarding.choosePlan') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'TrialPeriodBar',
  data() {
    return {
      countdown: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      loadInterval: null,
    };
  },
  computed: {
    ...mapState(['accountInfo']),
    showTrialAlert() {
      const { planName, planPrice, trialDaysLeft } = this.accountInfo;
      if (planName === 'Trial') {
        return 'trialPlan';
        //  TODO: Create better condition for trial info alert
      } else if (trialDaysLeft > 0 && planPrice > 0) {
        return 'pickedPlan';
      }
      return null;
    },
  },
  mounted() {
    this.offerTimeLeft();
  },
  methods: {
    ...mapActions(['trackAnalytics']),

    SGcta() {
      this.trackAnalytics('ChoosePlan TopAlert');
    },
    goToPricing() {
      this.$store.commit('app/addManualHistory', this.$route);
      this.$router.push({ name: 'PlanPick' });
      this.SGcta();
    },
    offerTimeLeft() {
      if (this.accountInfo.onboardingOffer) {
        const countDownDate = new Date(this.accountInfo.onboardingOffer).getTime();
        // Run every second
        this.loadInterval = setInterval(() => {
          const now = new Date().getTime();
          const dayInMilliseconds = 1000 * 3600 * 24;
          const timeleft = countDownDate - now;
          const progress = (timeleft / dayInMilliseconds) * 100;
          this.setProgress(progress);

          // Calculating the hours, minutes and seconds left
          const hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
          this.setTimeLeft(hours, minutes, seconds);

          if (this.countdown <= 0) {
            clearInterval(this.loadInterval);
          }
        }, 1000);
      }
    },
    setProgress(progress) {
      this.countdown = progress;
    },
    setTimeLeft(hours, minutes, seconds) {
      this.hours = hours;
      this.minutes = minutes;
      this.seconds = seconds;
    },
  },
  watch: {
    countdown: {
      handler(value) {
        if (value <= 0) {
          clearInterval(this.loadInterval);
        }
      },
      deep: true,
      immediate: true,
    },
    'accountInfo.onboardingOffer': {
      handler(value) {
        if (value) {
          this.offerTimeLeft();
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped></style>
